import { useMutation } from "@apollo/client";
import { PUT_ENCODED_DATA } from "components/gql/gql_queries_markcode";
import { logGQLError } from "data/functions";

export function ExtPutEncodedDataMutation() {
  const queryName = "ExtPutEncodedData";
  const [mutation, variables] = useMutation(PUT_ENCODED_DATA, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (data?.mrkcd_PutEncodedData.code === 200) {
      } else {
        logGQLError(queryName, data?.mrkcd_PutEncodedData);
      }
    },
    onError: (e) => {
      logGQLError(queryName, e);
    },
  });
  return [mutation, variables];
}
